export default "__VITE_ASSET__62ee25f7__"